import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import CustomButton from './CustomButton';

const useStyles = makeStyles({
  headerContainer: {
    width: '100%',
    height: '72px',
    padding: '24px 16px 24px 16px',
    background: 'white',
  },
  contentContainer: {
    width: '100%',
    padding: '16px',
    overflow: 'auto',
  },
  buttonContainer: {
    marginTop: 'auto',
    background: '#FFFFFF',
    width: '100%',
    height: '64px',
    border: '1px',
  },
});

const CustomModal = ({
  isOpen,
  handleClose,
  title,
  content,
  onSave,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
  disableSave = false,
  width = '527px',
  height = '744px',
}) => {
  const classes = useStyles();

  const style = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width,
    height,
    backgroundColor: '#F2F4F7',
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box sx={style}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          className={classes.headerContainer}
        >
          <Grid item>
            <div style={{ fontSize: '20px', fontWeight: '600', color: '#000' }}>{title}</div>
          </Grid>
          <Grid item>
            <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        <Grid container direction="column" className={classes.contentContainer}>
          {content}
        </Grid>

        <Grid container justifyContent="flex-end">
          <Grid item className={classes.buttonContainer}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              style={{ height: '100%' }}
              spacing={1}
            >
              <Grid item>
                <CustomButton label={cancelLabel} type="secondary" onClick={handleClose} />
              </Grid>
              <Grid item style={{ marginRight: '6px' }}>
                <CustomButton label={saveLabel} type="primary" onClick={onSave} disabled={disableSave} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CustomModal;
